import React, { useEffect, useContext, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../contexts/AppContext";
import GeneralButton from "../../../components/GeneralButton/GeneralButton";
import "../../../styles/globals.css";
import "./MailSettingPage.css";
import { Form, Input } from "antd";
import { ExclamationCircleOutlined, WarningFilled } from "@ant-design/icons";
import { sendCertificationNumberMailWhenEmailUpdate } from "../../../services/service";
import { showToast } from "../../../utils/commonUtils";
import { validateEmail } from "../../../utils/validationUtils";

function MailSettingPage() {
  const navigate = useNavigate();
  const { setGlobalEmailAddress, globalLoginUserInfo, globalAccessToken } =
    useContext(AppContext);
  const [form] = Form.useForm();
  const [errors, setErrors] = useState({});
  const [errorMessage, setErrorMessage] = useState(null);

  const emailInput = useRef(null);

  useEffect(() => {
    emailInput.current.input.focus();
  }, [errors?.email]);

  // メールアドレス変更処理
  const handlePasswordSendClick = async () => {
    try {
      await form.validateFields();
      const values = form.getFieldsValue();
      const { email } = values;

      const data = await sendCertificationNumberMailWhenEmailUpdate(
        globalAccessToken,
        email,
        globalLoginUserInfo?.userInfo?.kanjiLast,
        globalLoginUserInfo?.userInfo?.kanjiFirst
      );
      if (data.result.status === "OK") {
        // 認証番号入力画面に遷移
        setGlobalEmailAddress(email);
        navigate("/mypage/mail-setting/certificatrion-number-input");
        showToast("認証番号メールを送付しました", "success");
      } else {
        // エラーメッセージセット
        setErrorMessage(data?.result?.error_message);
        showToast(data?.result?.error_message, "error");
      }
    } catch (error) {
      console.error("Error changeMailAddress:", error);
      showToast("メールアドレス変更に失敗しました", "error");
    }
  };

  /**
   * 戻るボタン押下時の処理
   * @param {} なし
   * @return {} なし
   */
  const handleBackClick = () => {
    navigate("/mypage/menu");
  };

  /**
   * 値変更時の処理
   * @param {string} fieldName - フィールド名
   */
  const onValueChange = async (fieldName) => {
    try {
      await form.validateFields([fieldName]);
      setErrors({ ...errors, [fieldName]: false });
      setErrorMessage(null);
    } catch (error) {
      setErrors({ ...errors, [fieldName]: true });
    }
  };

  return (
    <div className="mail-setting">
      <div className="main-area">
        <div className="title">メールアドレス変更</div>
        <div className="detail">
          新しいメールアドレスを入力してください。
          <br />
          変更用の認証コードを送信します。
        </div>
        {errorMessage && (
          <div className="error-area">
            <div className="icon-area">
              <WarningFilled className="icon" />
            </div>
            <label>{errorMessage}</label>
          </div>
        )}
        <div className="form">
          <Form
            form={form}
            name="password-regist"
            layout="vertical"
            initialValues={{ remember: true }}
          >
            <Form.Item
              className="ant-label"
              label="メールアドレス"
              name="email"
              rules={[
                {
                  required: true,
                  message: "メールアドレスを入力してください",
                },
                { validator: validateEmail },
              ]}
              validateTrigger="onChange"
            >
              <Input
                className="ant-input"
                placeholder="例)example@example.com"
                ref={emailInput}
                suffix={errors.email ? <ExclamationCircleOutlined /> : null}
                onChange={() => {
                  onValueChange("email");
                }}
              />
            </Form.Item>
          </Form>
          <div className="general-buttons">
            <GeneralButton
              buttonLabel={"送信"}
              type={
                Object.values(errors).some((error) => error)
                  ? "disabled"
                  : "primary-blue"
              }
              onClick={handlePasswordSendClick}
            />
            <GeneralButton
              buttonLabel={"マイページに戻る"}
              type={"secondary-white"}
              onClick={handleBackClick}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default MailSettingPage;
